<template>
  <div class="member-center">
    <div class="header ub ubv ubv-c">
      您当前账号等级为
      <img
        v-if="levelList[userLevel]"
        width="40%"
        :src="levelList[userLevel].icon"
      />
    </div>
    <div class="notice tx-c">
      60天内等级只升不降，最近评估时间：<span class="ck-time">{{
        levelCheckTime
      }}</span>
    </div>
    <div>
      <div
        class="levelInfo"
        v-if="Array.isArray(levelList[userLevel].condition)"
      >
        <div
          v-for="(condition, oi) in levelList[userLevel].condition"
          :class="['condition_' + oi]"
          :key="oi"
        >
          <div
            class="item ub ubv-c"
            v-for="(item, key, index) in condition"
            :key="index"
          >
            <canvas :id="key" :width="canvasW" :height="canvasH"></canvas>
            <div class="ub ubv ub-sb uf1 content">
              {{ levelCondition[key] }}
              <div class="nums u-t">
                <span class="now-num">
                  {{
                    (levelLogList && levelLogList[0] && levelLogList[0][key]) ||
                      0
                  }}
                </span>
                (目标：≥ {{ item || 0 }})
              </div>
            </div>
            <div class="yester-data ub ubv tx-c">
              <div class="num">{{ getYesTerData(key) }}</div>
              <div class="gray">昨日</div>
            </div>
          </div>
        </div>
      </div>
      <div class="levelInfo" v-else>
        <div
          class="item ub ubv-c"
          v-for="(item, key, index) in levelList[userLevel].condition"
          :key="index"
        >
          <canvas :id="key" :width="canvasW" :height="canvasH"></canvas>
          <div class="ub ubv ub-sb uf1 content">
            {{ levelCondition[key] }}
            <div class="nums u-t">
              <span class="now-num">
                {{
                  (levelLogList && levelLogList[0] && levelLogList[0][key]) || 0
                }}
              </span>
              (目标：≥ {{ item || 0 }})
            </div>
          </div>
          <div class="yester-data ub ubv tx-c">
            <div class="num">{{ getYesTerData(key) }}</div>
            <div class="gray">昨日</div>
          </div>
        </div>
      </div>
    </div>
    <div class="conditions-info ub ubv-c">
      <div v-for="i in 3" :class="'item condition_' + (i - 1)" :key="i"></div>
      <span class="txt">
        完成等级内任意一种色区任务即可升级!
      </span>
    </div>

    <div class="recommend">
      <div class="title acea-row row-center-wrapper">
        <span class="iconfont icon-zhuangshixian"></span>
        <span class="name">会员权益</span>
        <span class="iconfont icon-zhuangshixian lefticon"></span>
      </div>
    </div>
    <div class="level-list ub">
      <div class="condition ub ubv">
        <div class="item-0 zhibiao">指标 \ 级别</div>
        <div
          class="item-0"
          v-for="(item, key, index) in levelCondition"
          :key="index"
        >
          {{ item }}
        </div>
        <div class="item-0 commission">自购返佣（%）</div>
        <div class="item-0 commission">一级返佣（%）</div>
        <div class="item-0 commission">二级返佣（%）</div>
      </div>
      <div
        :class="[
          'level uf1 ub ubv ubh-c tx-c',
          index == userLevel ? 'active-level' : ''
        ]"
        v-for="(item, index) in levelList"
        :key="index"
      >
        <div class="item-1">
          <img :src="item.icon" class="level-icon" />
        </div>
        <div v-if="Array.isArray(item.condition)">
          <div
            v-for="(condition, ci) in item.condition"
            :class="['ub ubv', 'condition_' + ci]"
            :key="ci"
          >
            <div v-for="(con, k, i) in condition" class="item-1" :key="i">
              {{ con }}
            </div>
          </div>
        </div>
        <div v-else class="ub ubv">
          <div v-for="(con, k, i) in item.condition" class="item-1" :key="i">
            {{ con }}
          </div>
        </div>

        <div class="item-1" v-for="(com, k) in item.commission_rate" :key="k">
          {{ parseInt(com * 100) }}
        </div>
      </div>
    </div>
    <div class="recommend">
      <div class="title acea-row row-center-wrapper">
        <span class="iconfont icon-zhuangshixian"></span>
        <span class="name">指标报表</span>
        <span class="iconfont icon-zhuangshixian lefticon"></span>
      </div>
    </div>
    <div class="select ub tx-c">
      <div
        class="item uf1"
        v-for="(item, index) in seriesArr"
        :key="index"
        @click="changeLvlog(index)"
      >
        <span :class="activeLvLogIndex == index ? 'active' : ''">
          {{ item.name }}
        </span>
      </div>
    </div>
    <canvas
      id="levelLog"
      :width="lcanvasW"
      :height="lcanvasH"
      disable-scroll="true"
      @touchstart="touchMix"
      @touchmove="moveMix"
      @touchend="touchEndMix"
    ></canvas>
  </div>
</template>
<style lang="scss">
.header {
  color: #c3b694;
  font-size: 0.35rem;
  font-weight: bold;
}

.levelInfo {
  padding-left: 0.2rem;
  .item {
    padding: 0.2rem 0;
    border-bottom: #dddddd 1px solid;
  }
}
.conditions-info {
  padding: 0.2rem;
  font-size: 0.22rem;
  color: #999999;
  .item {
    margin-right: 0.2rem;
    border: 2px solid;
    width: 0.4rem;
    height: 0.4rem;
  }
  .txt {
    color: rgb(64, 158, 255);
  }
}
.notice {
  margin: 0.2rem 0.5rem;
  border-radius: 0.3rem;
  padding: 0.1rem;
  background: rgb(242, 246, 252);
  color: #bbbbbb;
  font-size: 0.23rem;
  .ck-time {
    color: #2a7efb;
  }
}
.content {
  margin-left: 0.2rem;
  .nums {
    margin-top: 0.1rem;
    color: #999999;
    .now-num {
      color: #000000;
      font-size: 0.45rem;
    }
    .con-num {
      font-size: 0.3rem;
    }
  }
}
.yester-data {
  padding: 0 0.2rem;
  .num {
    font-size: 0.65rem;
    color: #000000;
  }
  .gray {
    color: #499cf5;
    font-size: 0.22rem;
  }
}
.condition_ {
  &0 {
    background: rgb(225, 243, 216);
  }
  &1 {
    background: rgb(250, 236, 216);
  }
  &2 {
    background: rgb(253, 226, 226);
  }
}
.level-list {
  margin: 0 0.2rem;
  border: 1px solid #dddddd;
  border-radius: 0.3rem;
  padding: 0.2rem;

  .active-level {
    border: 3px solid #fdbd69;
  }
  .zhibiao {
    color: rgb(64, 158, 255);
  }
  .item {
    &-0 {
      display: inline-flex;
      height: 1rem;
      align-items: center;
      justify-content: flex-start;
    }
    &-1 {
      display: inline-flex;
      height: 1rem;
      align-items: center;
      justify-content: center;
    }
  }
  .commission {
    color: red;
  }
  .level-icon {
    width: 0.5rem;
    align-self: center;
  }
}
.select {
  font-size: 0.22rem;
  margin: 0.3rem 0;
  .item {
    span {
      display: inline-block;
      min-width: 1.5rem;
      padding: 0.12rem;
      &.active {
        border: #1abb1d solid 1px;
        border-radius: 0.3rem;
      }
    }
  }
}
#levelLog {
  width: 100%;
}
</style>
<script>
import { getUserInfo, getLevelLogList, getLevelConf } from "../../api/user";
import uCharts from "uCharts";

let categories = [];
export default {
  name: "Poster",
  props: {},
  data: function() {
    return {
      canvasObj: null,
      levelList: [[], [], [], [], []], //等级列表
      userLevel: 0, //等级要求
      loading: false,
      levelLogList: [],
      canvasW: 90,
      canvasH: 90,
      levelCondition: [],
      lcanvasW: 400,
      lcanvasH: 300,
      activeLvLogIndex: 2,
      levelCheckTime: "",
      yAxisMax: 10,
      seriesArr: [
        {
          name: "日",
          yAxisMax: 10,
          data: [
            {
              name: "日消费",
              data: [],
              type: "line",
              style: "curve",
              key: "consume",
              show: true
            },
            {
              name: "日拉新",
              data: [],
              type: "column",
              style: "curve",
              // "color": "#1890ff",
              key: "sub_nums",
              show: true
            },
            {
              name: "子日消费",
              data: [],
              type: "column",
              // "color": "#f04864",
              key: "sub_consume",
              show: true
            }
          ]
        },
        {
          name: "近60天",
          yAxisMax: 10,
          data: [
            {
              name: "近60天拉新",
              data: [],
              type: "column",
              // "color": "#2fc25b",
              key: "month_sub_nums",
              show: true
            },
            {
              name: "近60天消费",
              data: [],
              type: "area",
              key: "month_consume",
              show: true
            },
            {
              name: "近60天子消费",
              data: [],
              type: "line",
              // "color": "#f04864",
              key: "month_sub_consume",
              show: true
            }
          ]
        },
        {
          name: "累计",
          yAxisMax: 10,
          data: [
            {
              name: "累计消费",
              data: [],
              type: "area",
              key: "total_consume",
              show: true
            },
            {
              name: "累计拉新",
              data: [],
              type: "area",
              // "color": "#f04864",
              key: "total_sub_nums",
              show: true
            },
            {
              name: "子累计消费",
              data: [],
              type: "area",
              // "color": "#f04864",
              key: "total_sub_consume",
              show: true
            }
          ]
        }
      ]
    };
  },
  watch: {
    $route(to) {
      if (to.name != "UserVip") return;
      this.getInfo();
      this.getLevelLogList();
      this.getUserInfo();
      this.canvasObj = null;
    }
  },
  mounted() {
    this.getInfo();
    this.getLevelLogList();
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserInfo().then(r => {
        this.userLevel = r.data.level;
        this.levelCheckTime = r.data.level_check_time || "";
      });
    },
    changeLvlog(index) {
      this.activeLvLogIndex = index;
      this.showGauge();
    },
    getYesTerData(key) {
      let nowData = this.levelLogList[0] || {};
      key = key.replace("month_", "");
      let r = nowData[key] || 0;
      return r ? "+" + r : r;
    },
    getLevelLogList() {
      getLevelLogList().then(r => {
        this.levelLogList = r.data;
        let arr = this.seriesArr;
        categories = [];
        r.data.forEach(item => {
          arr.forEach(group => {
            group.data.forEach(s => {
              let val = item[s.key] * 1;
              if (group.yAxisMax < val) {
                group.yAxisMax = val;
              }
              s.data.push(val);
            });
          });
          categories.push(item.time.toString().slice(5));
        });
        this.seriesArr = arr;
      });
    },
    initCanves() {
      let con = this.levelList[this.userLevel].condition;
      let nowData = this.levelLogList[0] || {};
      let levelCondition = this.levelCondition;
      for (let x in levelCondition) {
        let bl = con[x] ? (nowData[x] ? nowData[x] / con[x] : 0) : 1;
        bl = bl.toFixed(2);
        let chartData = {
          series: [
            {
              name: bl == 1 ? "达标" : "努力",
              data: bl,
              color: "#8FC94B"
            }
          ]
        };
        new uCharts({
          canvasId: x,
          type: "arcbar",
          fontSize: 11,
          legend: { show: false },
          background: "#FFFFFF",
          pixelRatio: 1,
          series: chartData.series,
          animation: true,
          width: this.canvasW,
          height: this.canvasH,
          dataLabel: true,
          title: {
            name: Math.round(chartData.series[0].data * 100) + "%", //这里我自动计算了，您可以直接给任意字符串
            color: chartData.series[0].color,
            fontSize: 20
          },
          subtitle: {
            name: chartData.series[0].name, //这里您可以直接给任意字符串
            color: "#8FC94B",
            fontSize: 12
          },
          extra: {
            arcbar: {
              type: "circle", //整圆类型进度条图
              width: 6, //圆弧的宽度
              startAngle: 0.5 //整圆类型只需配置起始角度即可
            }
          }
        });
      }

      this.showGauge();
    },
    getInfo() {
      getLevelConf().then(
        res => {
          this.levelList = res.data;
          this.levelCondition = res.level_condition;
          setTimeout(() => {
            this.initCanves();
          }, 300);
        },
        err => {
          this.$dialog.message(err.msg);
        }
      );
    },
    touchLegend(e) {
      let index = this.canvasObj.getLegendDataIndex(e);
      if (index == -1) return;
      this.seriesArr[this.activeLvLogIndex].data[index].show = !this.seriesArr[
        this.activeLvLogIndex
      ].data[index].show;
    },
    touchMix(e) {
      this.canvasObj.scrollStart(e);
      this.touchLegend(e);
    },
    moveMix(e) {
      this.canvasObj.scroll(e);
    },
    touchEndMix(e) {
      this.canvasObj.scrollEnd(e);
      //下面是toolTip事件，如果滚动后不需要显示，可不填写
      this.canvasObj.showToolTip(e, {
        format: function(item, category) {
          return category + "号 " + item.name + ":" + item.data;
        }
      });
    },
    getYmax() {
      let y = this.seriesArr[this.activeLvLogIndex].yAxisMax;
      y = parseInt(y + y / 10);
      console.log("y", y);
      return y < 10 ? 10 : y;
    },
    showGauge() {
      // console.log('this.seriesArr[this.activeLvLogIndex].data',this.seriesArr[this.activeLvLogIndex].data)
      this.canvasObj = new uCharts({
        canvasId: "levelLog",
        type: "mix",
        fontSize: 11,
        legend: {
          show: true,
          margin: 20,
          lineHeight: 30,
          borderWidth: 2,
          itemGap: 20,
          padding: 10
        },
        title: {
          name: "指标报表", //这里我自动计算了，您可以直接给任意字符串
          fontSize: 20
        },
        xAxis: {
          disableGrid: true,
          type: "grid",
          gridType: "dash",
          itemCount: 4,
          scrollShow: true,
          scrollAlign: "right"
        },
        yAxis: {
          gridType: "dash",
          // splitNumber: 5,
          // min: 10,
          max: this.getYmax(),
          format: val => {
            return val.toFixed(0);
          }
        },
        extra: {
          tooltip: {
            bgColor: "#000000",
            bgOpacity: 0.7,
            gridType: "dash",
            dashLength: 8,
            gridColor: "#1890ff",
            fontColor: "#FFFFFF",
            horizentalLine: true,
            xAxisLabel: true,
            yAxisLabel: true,
            labelBgColor: "#DFE8FF",
            labelBgOpacity: 0.95,
            labelAlign: "left",
            labelFontColor: "#666666"
          }
        },
        background: "#FFFFFF",
        enableScroll: true, //开启图表拖拽功能
        pixelRatio: 1,
        categories: categories,
        series: this.seriesArr[this.activeLvLogIndex].data,
        animation: true,
        width: this.lcanvasW,
        height: this.lcanvasH,
        dataPointShape: true,
        dataLabel: true
      });
      // canvasObj.addEventListener('renderComplete', () => {
      //     // your code here
      //     console.log('over', this.seriesArr[this.activeLvLogIndex].data)
      // });
    }
  }
};
</script>
